// Pick a generator before its original source, so a generator with more source
// papers does not silently gain more weight in a reviewed course family.
export function chooseBasicCourseSource(sources, {equalGeneratorWeights=false, random=Math.random}={}) {
  if(!sources.length)return undefined;
  let candidates=sources;
  if(equalGeneratorWeights){
    const byType=new Map();
    sources.forEach(source=>{
      if(!byType.has(source.type))byType.set(source.type,[]);
      byType.get(source.type).push(source);
    });
    const generators=[...byType.values()];
    candidates=generators[Math.floor(random()*generators.length)];
  }
  return candidates[Math.floor(random()*candidates.length)];
}
